"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Colors = _interopRequireDefault(require("../../Basic/Colors/Colors"));

var _Icon = _interopRequireDefault(require("../../Graphics/Icon/Icon"));

require("../FileInput/FileInput.css");

require("../../Typography/Paragraph/Paragraph.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @visibleName Add Row Button
 */
function AddButton(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick;
  var useStyles = (0, _styles.makeStyles)({
    root: {
      color: _Colors.default.sinineVaal,
      '&:after': {
        content: '"'.concat(children).concat('"')
      }
    }
  });
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("label", {
    className: classes.root.concat(' custom-file-input paragraph css-14'),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "times",
    color: _Colors.default.sinineVaal,
    margin: "3px",
    size: "18px"
  }));
}

AddButton.propTypes = {
  /** Elements to be rendered as children of this component */
  children: _propTypes.default.string,

  /** Gets called when the user clicks on the button */
  onClick: _propTypes.default.func
};
AddButton.defaultProps = {
  children: 'Lisa',
  onClick: function onClick(event) {
    // eslint-disable-next-line no-console
    console.log('You have clicked me!', event.target);
  }
};
var _default = AddButton;
exports.default = _default;